import { ReactNode } from 'react'
import Table, { TableProps } from 'rc-table'
import styled from 'styled-components'

type TableWrapperProps<RecordType = unknown> = TableProps<RecordType> & {
  children?: ReactNode
}

const TableWrapper = <RecordType,>({ children, ...props }: TableWrapperProps<RecordType>) => (
  <TableContainer {...props}>{children}</TableContainer>
)

const TableContainer = styled(Table)<TableProps<any>>`
  .rc-table-thead {
    background-color: rgb(250, 250, 250);
  }
  .rc-table-cell {
    padding: 8px;
    border-bottom: 1px solid rgb(240, 240, 240);
  }
  table {
    width: 100%;
  }
`

export default TableWrapper
